import styled from 'styled-components';

export const H1 = styled.h1`
  font-size: ${props => props.theme.fontVariants.h1.size};
  line-height: ${props =>
    props.lineHeight
      ? props.lineHeight
      : props.theme.fontVariants.h1.lineHeight};
  color: ${props =>
    props.color
      ? props.theme.colorPalette[props.color]
      : props.theme.fontVariants.h1.color};
  display: ${props => (props.display ? props.display : ' inline-block')};
  margin: ${props => (props.margin ? props.margin : ' 0px')};
  margin-bottom: ${props => props.marginBottom};
  margin-top: ${props => props.marginTop};
`;
